module.exports = __webpack_public_path__ + "static/media/rsm-darkClose.e07d0a99.svg";